// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "1565401";
